<div class="overlay" *ngIf="show">
      <div class="modal">
        <h2>You will be logged out soon</h2>
        <p>You’ve been inactive. You’ll be logged out in <strong>{{ countdown }}s</strong>.</p>
        <button (click)="stayLoggedIn()">Stay Logged In</button>
      </div>
</div>